// extracted by mini-css-extract-plugin
export default {"container":"Research_container__yfJ+V","title":"Research_title__bAQ0A","description":"Research_description__I8u7P","orderBy":"Research_orderBy__foMwh"};